import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import notFind from '@/components/find'
Vue.use(Router)
//  window.location.href = '/404'
const router = new Router({
  base: 'pmsweb',
  routes: [{
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: 'notFind',
      component: notFind,
      // meta: {
      //     title: '404未找到',
      // },
      name: 'notFind'
    },


  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  history: true,
})
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('notFind');
  } else {
    next(); //如果匹配到正确跳转
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js